import fetchJsonp from 'fetch-jsonp';

class Gift {
  constructor(cont) {
    this.$ = cont;
    this.defaultBorder = 10;
    this.brc = this.$.dataset.brc ? this.$.dataset.brc : 'brac010';

    // loadingがあれば対応
    this.loading = this.$.querySelector('.js-zaiko-loading');

    // 商品情報取得
    if (this.$.dataset.shohincd) {
      this.shohincd = this.$.dataset.shohincd;
      this.itemJanArr = this.shohincd.split(',');
      this.itemBorder = this.$.dataset.border;
      if (this.itemBorder) {
        let itemBorderArr = new Array();
        itemBorderArr = this.itemBorder.split(',');
        this.customItemBorderArr = itemBorderArr;
      }
    }

    // 景品情報取得
    if (this.$.querySelector('.js-gift-keihin')) {
      this.giftInput = this.$.querySelector('.js-gift-keihin');
      this.giftShohincd = this.giftInput.dataset.shohincd;
      this.giftJanArr = this.giftShohincd.split(',');
      this.giftBorder = this.giftInput.dataset.border;
      if (this.giftBorder) {
        let giftBorderArr = new Array();
        giftBorderArr = this.giftBorder.split(',');
        this.customGiftBorderArr = giftBorderArr;
      }
    }

    // 在庫API情報
    this.domain = location.origin;
    this.zaikoAPIPath = "/sw/products/SWFG070740.seam";
    this.janParamKey = '&shohin_cd=';

    // ドメイン判定&在庫API URLセット
    let apiURL = '';
    let cartDomain = '';
    if (this.domain.indexOf("shiseido.co.jp") != -1) {
      apiURL = this.zaikoAPIPath;
    } else {
      apiURL = 'https://www.shiseido.co.jp' + this.zaikoAPIPath;
      cartDomain = 'https://www.shiseido.co.jp';
    }
    this.apiURL = apiURL;

    // コールバックURL
    let callBackURL = '';
    if (this.domain.indexOf("shiseido.co.jp") != -1) {
      callBackURL = this.domain + location.pathname;
    } else {
      callBackURL = 'https://www.shiseido.co.jp' + location.pathname;
    }
    this.callBackURL = encodeURIComponent(callBackURL);

    // カートリンク設置
    this.cartBaseHref = cartDomain + '/sw/auth/SWFG014120.seam?brc=' + this.brc + '&_kss_next_url=';
    this.giftCartBaseHref = '/sw/products/SWFG070650.seam?actionMethod=/products%2FSWFG070650.xhtml%3AsWFG070650Action.addCartGiftSetShohin';
    // 相手に送るリンク
    if (this.$.dataset.gift_set_code) {
      this.giftLinkURL = this.giftCartBaseHref + '&giftset_cd=' + this.$.dataset.gift_set_code + '&giftset_lp_url=' + this.callBackURL;
      this.giftLinkURL = this.cartBaseHref + encodeURIComponent(this.giftLinkURL);
      let giftCartArr = Array.from(this.$.querySelectorAll('.js-gift-link'));
      giftCartArr.forEach((link) => {
        link.href = this.giftLinkURL;
      })
    }
    // 自分に送るリンク
    if (this.$.dataset.self_set_code) {
      this.selfLinkURL = this.giftCartBaseHref + '&giftset_cd=' + this.$.dataset.self_set_code + '&giftset_lp_url=' + this.callBackURL;
      this.selfLinkURL = this.cartBaseHref + encodeURIComponent(this.selfLinkURL);
      let selfCartArr = Array.from(this.$.querySelectorAll('.js-self-link'));
      selfCartArr.forEach((link) => {
        link.href = this.selfLinkURL;
      })
    }

    if (this.$.querySelector('.js-gift-link')) {
      this.giftLinkArr = Array.from(this.$.querySelectorAll('.js-gift-link'));
    }
    if (this.$.querySelector('.js-self-link')) {
      this.selfLinkArr = Array.from(this.$.querySelectorAll('.js-self-link'));
    }

    this.initialize();

  }

  async initialize() {

    // 在庫判定文字列初期化
    let zaiko = '';
    let customZaiko = '';
    let itemZaiko = '';
    let giftZaiko = '';

    // 商品在庫(通常判定A)
    if (this.shohincd) {
      let itemParam = this.janParamKey + this.itemJanArr.join(this.janParamKey);
      itemParam = '?border=' + this.defaultBorder + '&shohin_kbn=1' + itemParam;
      const itemRes = await fetchJsonp(this.apiURL + itemParam);
      const itemData = await itemRes.json();
      itemZaiko = itemData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + itemZaiko;
    }

    // 商品在庫(カスタム判定B)
    if (this.customItemBorderArr) {
      for (let i = 0; i < this.itemJanArr.length; i++) {
        let itemParam = this.janParamKey + this.itemJanArr[i];
        itemParam = '?border=' + this.customItemBorderArr[i] + '&shohin_kbn=1' + itemParam;
        const itemRes = await fetchJsonp(this.apiURL + itemParam);
        const itemData = await itemRes.json();
        itemZaiko = itemData.map(function (value) {
          return value.zaiko_kbn;
        });
        customZaiko += ',' + itemZaiko;
      }
    }

    // 景品在庫（通常判定A）
    if (this.giftShohincd) {
      let giftParam = this.janParamKey + this.giftJanArr.join(this.janParamKey);
      giftParam = '?border=' + this.defaultBorder + '&shohin_kbn=2' + giftParam;
      const giftRes = await fetchJsonp(this.apiURL + giftParam);
      const giftData = await giftRes.json();
      giftZaiko = giftData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + giftZaiko;
    }

    // 景品在庫(カスタム判定B)
    if (this.customGiftBorderArr) {
      for (let i = 0; i < this.giftJanArr.length; i++) {
        let giftParam = this.janParamKey + this.giftJanArr[i];
        giftParam = '?border=' + this.customGiftBorderArr[i] + '&shohin_kbn=2' + giftParam;
        const giftRes = await fetchJsonp(this.apiURL + giftParam);
        const giftData = await giftRes.json();
        giftZaiko = giftData.map(function (value) {
          return value.zaiko_kbn;
        });
        customZaiko += ',' + giftZaiko;
      }
    }
    // 通常判定A
    let zaikoA = this.zaikoJudge(zaiko);
    // カスタム判定B
    if (customZaiko != '') {
      const zaikoB = this.zaikoJudge(customZaiko);
    }

    // ローディングパーツ削除
    if (this.loading) {
      this.loading.remove();
    }

    // 該当要素表示
    this.$.dataset.zaiko = zaikoA;
    const displayTarget = Array.from(this.$.querySelectorAll('.zaikokbn' + zaikoA));
    displayTarget.forEach(elm => {
      elm.style.display = 'block';
    })

  }

  zaikoJudge(str) {
    if (str.indexOf('9') != -1) {
      return 9;
    } else if (str.indexOf('0') != -1) {
      return 0;
    } else if (str.indexOf('2') != -1) {
      return 2;
    } else if (str.indexOf('1') != -1) {
      return 1;
    }
  }
}

const giftCarts = document.querySelectorAll('.js-gift');
const giftCompleteFlag = 'gift-completed';
const giftCb = function (entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      if (!entry.target.classList.contains(giftCompleteFlag)) {
        new Gift(entry.target);
        entry.target.classList.add(giftCompleteFlag);
      }
      observer.unobserve(entry.target);
    }
  });
};
const giftIOoptions = {
  root: null,
  rootMargin: "100px",
  threshold: 0
};
const giftIO = new IntersectionObserver(giftCb, giftIOoptions);
if (giftCarts) {
  giftCarts.forEach((cart, index) => {
    cart.setAttribute('data-gift_serial', index + 1);
    giftIO.observe(cart);
  });
}
